import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants.js";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressConversations from "../widgets/botpressConversations";
import BotpressConversationsAnalytics from "../widgets/botpressConversationsAnalytics.js";

const BotpressConversationPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Conversation History" />
      <PortalGridContent>
        <Grid size={{ xs: 12 }}>
          <BotpressConversations />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressConversationsAnalytics
            botpressGraphType={constants.botpressGraphTypes.conversationTopicsGraph}
            colorIndex={0}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressConversationsAnalytics
            botpressGraphType={constants.botpressGraphTypes.conversationSentimentGraph}
            colorIndex={0}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressConversationPortal);
